'use client'

// HeaderCtaAnalytics — the header CTA's analytics click-ping island (#118
// server-chrome, Step 5 prerequisite).
//
// The header CTA is now server-rendered via <CtaV2Server> (0 client JS), which —
// unlike the client <CtaV2> — intentionally DROPS the `onClick={() =>
// sendEvent(event)}` gtag ping the navigational link fired. That ping is a live
// behaviour we must NOT lose, so this ~10-line 'use client' wrapper re-attaches
// it WITHOUT declientifying the CTA: HeaderNavServer (a Server Component) renders
// <CtaV2Server> as this island's `children`, so the CTA markup stays server-only
// RSC output; this wrapper just owns the click handler.
//
// The wrapper IS the existing `styles.ctaWrapper` <div> (className passed in), so
// the DOM is identical to the old `<div className={styles.ctaWrapper}><a
// onClick=…></a></div>`. The click bubbles from the inner <a> up to this div's
// onClick, firing sendEvent(event) exactly as the client link did (mouse + the
// keyboard-activation click browsers synthesise for anchors).

import React from 'react'
import PropTypes from 'prop-types'
import sendEvent from '../../utils/analytics'

function HeaderCtaAnalytics({ event, className, children }) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className={className} onClick={() => sendEvent(event)}>
      {children}
    </div>
  )
}

HeaderCtaAnalytics.propTypes = {
  // The analytics event descriptor ({ name, parameters }) — sendEvent ignores a
  // falsy/nameless value, so an undefined event is a safe no-op (unchanged).
  event: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
}

export default HeaderCtaAnalytics
